import axios, { getData } from "lib/axios";

export const getAllReports = async () => {
  return axios.get("/reports").then(getData);
};

export const getQueryReports = async ({ status }) => {
  return axios.get(`/reports?status=${status}`).then(getData);
};

export const postNewReport = async (data) => {
  return axios.post("/reports", data).then(getData);
};

export const getReport = async ({ id, signal }) => {
  return axios.get(`reports/${id}`).then(getData);
};

export const deleteReport = async (id) => {
  return axios.delete(`reports/${id}`).then(getData);
};

export const postSubmitReport = async (id) => {
  return axios.post(`reports/${id}/submit`).then(getData);
};

export const putEditReport = async (data, id) => {
  return axios.put(`/reports/${id}`, data).then(getData);
};

export const getWithdrawReport = async (id) => {
  return axios.get(`reports/${id}/withdraw`).then(getData);
};
